import { z } from 'zod';
/**
 * Contrats du nouveau système « Taguer » (refonte de l'ancien « Valider les tags IA »).
 * Source UNIQUE front + back.
 *
 * Modèle métier (décisions produit) :
 *  - Les TAGS d'une photo = ses liaisons `asset_tags` en `status = 'validated'`. C'est
 *    BINAIRE (tagué / pas tagué) : AUCUN poids 0..5, AUCUN « rejet » (`status = 'rejected'`
 *    est abandonné, cf. migration 0025).
 *  - Une photo porte un drapeau booléen `tagged` : « un humain a statué sur ses tags ».
 *    Posé UNIQUEMENT lors d'un commit explicite (`POST /api/assets/:id/tags/set`), y
 *    compris avec ZÉRO tag coché. Pas d'horodatage (booléen simple).
 *  - Les propositions IA (`status = 'proposed'`, avec `confidence`) restent AFFICHÉES à
 *    titre indicatif (barre de confiance côté front) mais ne sont JAMAIS cochées d'office.
 */
/**
 * Une ligne du panneau de tagging : un tag de la taxonomie de la bibliothèque, l'état
 * « coché » (= liaison validée) de la photo pour ce tag, et la confiance IA associée à
 * la liaison si elle existe. `confidence` peut être présente MÊME sur un tag coché (une
 * proposition IA validée conserve sa confiance) ; `null` si aucune liaison (ou liaison
 * sans confiance).
 */
export const assetTagRowSchema = z.object({
    tagId: z.uuid(),
    label: z.string(),
    checked: z.boolean(),
    confidence: z.number().nullable(),
});
/**
 * Lecture du tagging d'une photo (`GET /api/assets/:id/tagging`) : son drapeau `tagged`
 * + TOUTE la taxonomie de la bibliothèque (ordre alphabétique), FUSIONNÉE avec les
 * liaisons de la photo (coché / confiance). Le front peint une case par tag.
 */
export const assetTaggingSchema = z.object({
    assetId: z.uuid(),
    tagged: z.boolean(),
    tags: z.array(assetTagRowSchema),
});
/**
 * Corps de `POST /api/assets/:id/tags/set` : le set EXACT des tags cochés. Il REMPLACE
 * l'ensemble des tags validés de la photo (les tags absents de la liste sont décochés).
 * Une liste VIDE = commit à zéro tag (la photo est marquée `tagged` sans porter de tag).
 *
 * PAS de `.transform` (piège Zod v4 → `z.toJSONSchema` lève au boot ; cf.
 * `route-json-schema.test.ts`). Plafond défensif de la sélection (2000) borné à la DB.
 */
export const setAssetTagsRequestSchema = z.object({
    tagIds: z.array(z.uuid()).max(2000),
});
/**
 * Résultat d'un commit : la photo est désormais `tagged` (toujours `true`), et le nombre
 * de tags EFFECTIVEMENT validés (les ids cochés qui appartiennent bien à la taxonomie de
 * la bibliothèque ; un id inconnu/étranger est silencieusement ignoré, jamais lié).
 */
export const setAssetTagsResultSchema = z.object({
    tagged: z.literal(true),
    validatedCount: z.number().int().nonnegative(),
});
//# sourceMappingURL=tagging.js.map